import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import Products from 'merchandise-lib/constants/Product';
import { FreeToolsFAQs } from 'pricing-pages-ui-components/frequentlyAskedQuestions/FreeToolsFAQs';
import LimitUsageSection from 'pricing-pages-ui-components/limit-usage/LimitUsageSection';
import { PageSubTitle, PageTitle } from 'pricing-pages-ui-components/semantic/PageHeader';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import ComparePlansLink from '../../../components/common/ComparePlansLink';
import { CreditsCallout } from '../../../components/common/credits-callout/CreditsCallout';
import GenericBundleFeatureTable from '../../../components/feature-table/suite-feature-table/GenericBundleFeatureTable';
import { useDocumentTitle } from '../../../hooks/useDocumentTitle';
import { trackButtonClick, trackPageView } from '../../../v2/utils/tracking/trackingEventUtils';
import PhoneSupportMiddle from '../../components/phone-support/PhoneSupportMiddle';
import { SCREENS } from '../../constants/tracking/Screens';
import { SUITE_FEATURE_TABLE_HEADER } from '../../constants/tracking/TrackingSources';
import { BannerSection } from '../../containers/BannerSection';
import { FreeToolsMerchCards } from './FreeToolsMerchCards';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CORE_SEATS_API_NAMES = [Products.HUBSPOT_FREE, Products.CRM_SUITE_STARTER_BUNDLE];
export const FreeToolsPage = () => {
  useDocumentTitle('crm');
  useEffect(() => {
    trackPageView({
      screen: 'crm'
    });
  }, []);
  return /*#__PURE__*/_jsxs(NavMarker, {
    name: "FREE_TOOLS_PAGE_V2",
    children: [/*#__PURE__*/_jsx(BannerSection, {
      screen: "crm",
      apiNames: CORE_SEATS_API_NAMES
    }), /*#__PURE__*/_jsxs(View, {
      textAlign: "center",
      marginBlockEnd: "800",
      children: [/*#__PURE__*/_jsx(PageTitle, {
        "aria-level": 1,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.pagesV2.crm.pageTitle"
        })
      }), /*#__PURE__*/_jsx(PageSubTitle, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.pagesV2.crm.description"
        })
      })]
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(FreeToolsMerchCards, {})
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(CreditsCallout, {
        navItem: "crm"
      })
    }), /*#__PURE__*/_jsx(ComparePlansLink, {}), /*#__PURE__*/_jsx(LimitUsageSection, {
      isFreePortal: true,
      useCompactGrid: true,
      onExpandButtonClick: () => trackButtonClick({
        name: 'limitInteraction',
        action: 'clicked to expand limit cards section'
      }),
      onCollapseButtonClick: () => trackButtonClick({
        name: 'limitInteraction',
        action: 'clicked to collapse limit cards section'
      })
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(GenericBundleFeatureTable, {
        screen: SCREENS.FREE,
        trackingSource: SUITE_FEATURE_TABLE_HEADER,
        apiNames: [Products.HUBSPOT_FREE, Products.CRM_SUITE_STARTER_BUNDLE]
      })
    }), /*#__PURE__*/_jsx(PhoneSupportMiddle, {
      phoneSourceId: "crm-middle",
      screen: SCREENS.FREE,
      apiName: Products.CRM_SUITE_STARTER_BUNDLE
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(FreeToolsFAQs, {})
    })]
  });
};